export default __webpack_public_path__ + "static/media/logo.c197d83b.svg";